import { APIDataIntegration, APIMetaDataIntegrationPropertyNames } from '@evertel/types'
import { Store } from '@evertel/types'
import { decorate, injectable } from '@evertel/di'

class IntegrationStore extends Store<APIDataIntegration> {
    constructor() {
        super([...APIMetaDataIntegrationPropertyNames, 'apiKeys'])
    }
}

decorate(injectable(), IntegrationStore)

export { IntegrationStore }
